import React, { useState } from 'react';
import {
  Typography,
  Box,
  Paper,
  makeStyles,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';
import { SealedSecretTool } from './SealedSecretTool';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    minHeight: 600,
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2, 3),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  headerIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  headerTitle: {
    display: 'flex',
    flexDirection: 'column',
  },
  toolSelect: {
    minWidth: 200,
  },
  selectMenuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  selectIcon: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      fontSize: '1.2rem',
    },
  },
  content: {
    flex: 1,
    padding: theme.spacing(3),
    overflow: 'auto',
  },
}));

interface ToolDefinition {
  id: string;
  name: string;
  description: string;
  icon: React.ReactNode;
  component: React.ComponentType;
}

const tools: ToolDefinition[] = [
  {
    id: 'sealed-secret',
    name: 'SealedSecret 加密',
    description: '将敏感数据加密为 SealedSecret 格式',
    icon: <LockIcon />,
    component: SealedSecretTool,
  },
];

export const ToolsContent: React.FC = () => {
  const classes = useStyles();
  const [selectedTool, setSelectedTool] = useState<string>('sealed-secret');

  const selectedToolDef = tools.find(t => t.id === selectedTool);
  const ToolComponent = selectedToolDef?.component;

  return (
    <Paper className={classes.root}>
      <Box className={classes.header}>
        <Box className={classes.headerLeft}>
          <Box className={classes.headerIcon}>
            {selectedToolDef?.icon || <LockIcon />}
          </Box>
          <Box className={classes.headerTitle}>
            <Typography variant="h6">
              {selectedToolDef?.name || '开发工具'}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              {selectedToolDef?.description || '选择一个工具开始使用'}
            </Typography>
          </Box>
        </Box>

        <FormControl variant="outlined" size="small" className={classes.toolSelect}>
          <Select
            value={selectedTool}
            onChange={(e) => setSelectedTool(e.target.value as string)}
          >
            {tools.map(tool => (
              <MenuItem key={tool.id} value={tool.id}>
                <Box className={classes.selectMenuItem}>
                  <span className={classes.selectIcon}>{tool.icon}</span>
                  <span>{tool.name}</span>
                </Box>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box className={classes.content}>
        {ToolComponent && <ToolComponent />}
      </Box>
    </Paper>
  );
};

export default ToolsContent;
